"use client";

import { ShieldCheck, Truck, Banknote, RefreshCcw } from "lucide-react";
import { EditorField } from "@/config/ecoBuilder/types";
import { usePageContext } from '@/components/ecoBuilder/renderer/PageContext';

interface TrustBadgesProps {
    id: string;
    showShipping?: boolean;
    showCOD?: boolean;
    showWarranty?: boolean;
    showReturn?: boolean;
    iconColor?: string;
}

export function TrustBadges({
    id,
    showShipping = true,
    showCOD = true,
    showWarranty = true,
    showReturn = false,
    iconColor
}: TrustBadgesProps) {
    const { themeSettings } = usePageContext();
    const finalIconColor = iconColor || themeSettings?.primaryColor || "#16a34a";

    return (
        <div id={id} className="py-6 px-4">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl mx-auto">
                {showShipping && (
                    <div className="flex flex-col items-center text-center gap-2 p-3 bg-muted/50 rounded-lg">
                        <Truck className="w-8 h-8" style={{ color: finalIconColor }} />
                        <div>
                            <h4 className="font-bold text-foreground text-sm">توصيل سريع</h4>
                            <p className="text-xs text-muted-foreground">لجميع الولايات 58</p>
                        </div>
                    </div>
                )}

                {showCOD && (
                    <div className="flex flex-col items-center text-center gap-2 p-3 bg-muted/50 rounded-lg">
                        <Banknote className="w-8 h-8" style={{ color: finalIconColor }} />
                        <div>
                            <h4 className="font-bold text-foreground text-sm">الدفع عند الاستلام</h4>
                            <p className="text-xs text-muted-foreground">ادفع بعد معاينة المنتج</p>
                        </div>
                    </div>
                )}

                {showWarranty && (
                    <div className="flex flex-col items-center text-center gap-2 p-3 bg-muted/50 rounded-lg">
                        <ShieldCheck className="w-8 h-8" style={{ color: finalIconColor }} />
                        <div>
                            <h4 className="font-bold text-foreground text-sm">ضمان الجودة</h4>
                            <p className="text-xs text-muted-foreground">منتج أصلي 100%</p>
                        </div>
                    </div>
                )}

                {showReturn && (
                    <div className="flex flex-col items-center text-center gap-2 p-3 bg-muted/50 rounded-lg">
                        <RefreshCcw className="w-8 h-8" style={{ color: finalIconColor }} />
                        <div>
                            <h4 className="font-bold text-foreground text-sm">استبدال سهل</h4>
                            <p className="text-xs text-muted-foreground">في حالة وجود عيب</p>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

// ═══════════════════════════════════════════════════════════════
// REGISTRY EXPORTS
// ═══════════════════════════════════════════════════════════════

export const TrustBadgesDefaultProps = {
    showShipping: true,
    showCOD: true,
    showWarranty: true,
    showReturn: false,
    iconColor: "#16a34a"
};

export const TrustBadgesSchema: EditorField[] = [
    {
        key: "showShipping",
        label: "إظهار: توصيل سريع",
        type: "boolean",
        defaultValue: true
    },
    {
        key: "showCOD",
        label: "إظهار: الدفع عند الاستلام",
        type: "boolean",
        defaultValue: true
    },
    {
        key: "showWarranty",
        label: "إظهار: ضمان الجودة",
        type: "boolean",
        defaultValue: true
    },
    {
        key: "showReturn",
        label: "إظهار: استبدال/إرجاع",
        type: "boolean",
        defaultValue: false
    },
    {
        key: "iconColor",
        label: "لون الأيقونات",
        type: "color"
    }
];
